import * as React from "react";
import portalLogoS from "src/resources/themedportal-logo-small.png";

import { AppBar, Toolbar, Button, Select, MenuItem } from "@material-ui/core";
import { checkAuthStore, authStore } from "src/modules/auth/store";
import { autorun, observable, toJS } from "mobx";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { config } from "src/config";
import { history } from "src/history.js";
import { permissionsStore } from 'src/modules/admin/modules/Permissions';
import { Loading } from '../loading';

const styles = createStyles({
  appBar: {
    // marginBottom: "1.5rem"
  },
  logo: {
    display: "flex",
    height: "3rem",
  },
  spacer: {
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
  },
  button: {
    backgroundColor: "#bbb",
    border: "1px #eee solid",
  },
});

class StyledPortalAppBar extends React.Component<any> {
  @observable
  public loaded: boolean = false;

  public loadUser = autorun(() => {
    if (authStore.loaded) {
      this.loaded = true;
      this.loadUser();
      this.forceUpdate();
    }
  });

  public handleClick = (e: any) => {
    history.push("/dashboard");
  };

  public handleCompanyChange = (test: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    authStore.toggleActiveCompany(authStore.currentUser.auth_id, Number(e.target.value))
  }

  public handleSiteChange = (test: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    authStore.toggleActiveSite(authStore.currentUser.auth_id, Number(e.target.value))
  }

  public handleRoleChange = (test: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    authStore.toggleActiveRole(authStore.currentUser.auth_id, Number(e.target.value))
  }

  public componentDidMount = () => {
    permissionsStore.getAllPortalRoles();
    permissionsStore.getAllPermissionList();
  }

  public getRoleDropdown = () => {
    const { classes } = this.props;
    if (!authStore.loaded || !authStore.currentUser.SessionKey || !permissionsStore.portal_roles_loaded) {
      return null
    }
    else if (authStore.currentUser.portal_role_id === 1 || authStore.currentUser.portal_role_id === 2) {
      let rolesMap = permissionsStore.allPortalRoles;
      if (authStore.currentUser.portal_role_id === 2) {
        rolesMap = permissionsStore.allPortalRoles.filter((role: any) => role.portal_role_id !== 1)
      }
      return (
        <Select
          inputProps={{ name: "role_id", id: "role_id" }}
          value={authStore.currentUser.ViewingRole}
          classes={{ root: classes.roleSelect }}
          // tslint:disable-next-line: jsx-no-lambda
          onChange={this.handleRoleChange('')}
        >
          {rolesMap.map((role: any, index: number) => {
            return (
              <MenuItem key={index} value={role.portal_role_id}>
                {role.PortalRoleName}
              </MenuItem>
            );
          })}
        </Select>
      )
    }
    return null
  }

  public getSiteDropdown = () => {
    const { classes } = this.props;
    if (!authStore.loaded || !authStore.currentUser.SessionKey) {
      return null
    }
    else if (authStore.currentUser.ViewingRole === 4 && authStore.currentUser.Sites.length > 1) {
      const activeId = authStore?.currentUser?.Sites?.find(s => s.Active === 1)?.siteId
      return (
        <Select
          inputProps={{ name: "site_id", id: "site_id" }}
          value={activeId}
          classes={{ root: classes.roleSelect }}
          // tslint:disable-next-line: jsx-no-lambda
          onChange={this.handleSiteChange('')}
        >
          {authStore.currentUser.Sites
            .slice() // C-178
            .sort((a: any, b: any) => (a.displayName || '').localeCompare(b.displayName || ''))
            .map((site: any, index: number) => {
            return (
              <MenuItem key={index} value={site.siteId}>
                {site.displayName}
              </MenuItem>
            );
          })}

        </Select>
      )
    }
    return null

  }

  public getCompanyDropdown = () => {
    const { classes } = this.props;
    if (!authStore.loaded || !authStore.currentUser.SessionKey) {
      return null
    }
    else if (authStore.currentUser.ViewingRole === 3 && authStore.currentUser.Companies.length > 1) {
      const activeId = authStore.currentUser.Companies.find(c => c.Active === 1).company_id
      return (
        <Select
          inputProps={{ name: "company_id", id: "company_id" }}
          value={activeId}
          classes={{ root: classes.roleSelect }}
          // tslint:disable-next-line: jsx-no-lambda
          onChange={this.handleCompanyChange('')}
        // disabled={this.props.match.params.view_type === 'detail'}
        >
          {authStore.currentUser.Companies
            .slice() // C-180
            .sort((a: any, b: any) => (a.CompanyName || '').localeCompare(b.CompanyName || ''))
            .map((company: any, index: number) => {
            return (
              <MenuItem key={index} value={company.company_id}>
                {company.CompanyName}
              </MenuItem>
            );
          })}

        </Select>
      )
    }
    return null

  }

  public render() {
    const { classes } = this.props;
    // console.log(toJS(authStore))
    // console.log(toJS(permissionsStore))
    if (!permissionsStore.allPortalRoles || !permissionsStore.allPermissionList) {
      return (
        <AppBar position={"static"} className={classes.appBar} style={{boxShadow:'none',backgroundColor: 'white'}}> {/* // E-072 */}
          <Toolbar>
            <img
              className={classes.logo}
              src={portalLogoS}
              onClick={this.handleClick}
            />
            <div className={classes.spacer} />
          </Toolbar>
        </AppBar>
      )
    }
    return (
      <AppBar position={"static"} className={classes.appBar} style={{boxShadow:'none',backgroundColor: 'white'}}> {/* // E-072 */}
        <Toolbar>
          <img
            className={classes.logo}
            src={portalLogoS}
            onClick={this.handleClick}
          />
          <div className={classes.spacer} />
          {this.getRoleDropdown()}
          {this.getCompanyDropdown()}
          {this.getSiteDropdown()}
        </Toolbar>
      </AppBar>
    );
  }
}

export const PortalAppBar = withStyles(styles, { withTheme: true })(
  StyledPortalAppBar
);



// WEBPACK FOOTER //
// ./src/components/app-bar/PortalAppBar.tsx